import React, { Ref } from 'react'

import classNames from 'classnames'

import { ReviewAddMediaIcon } from '@local/assets/icons'

import { useGoTo } from '@web/hooks/useGoTo'
import useMe from '@web/hooks/useMe'
import routes from '@web/libs/constants/routes'

import Clickable from '../Clickable'
import styles from './ThemelistCard.module.scss'

interface Props {
  isReviewTab?: boolean
  clickCode: string
}

const NewThemelistCard = ({ isReviewTab, clickCode }: Props, ref: Ref<HTMLLIElement>) => {
  const { me } = useMe()
  const { goTo } = useGoTo()

  return (
    <li
      ref={ref}
      className={classNames(styles.list_item, styles.type_add, {
        [styles.type_review_tab]: isReviewTab,
      })}
    >
      <Clickable className={styles.list_item_link} nClickCode={clickCode} onClick={() => goTo(routes.THEME_NEW)}>
        <span className={styles.icon_area}>
          <ReviewAddMediaIcon className={styles.icon} aria-hidden="true" />
        </span>
        내 리뷰만 모아
        <br />
        테마만들기
      </Clickable>
    </li>
  )
}

export default React.forwardRef(NewThemelistCard)
